import { Component, ViewChild, ElementRef, OnInit, PLATFORM_ID, Inject, Input, HostListener, ChangeDetectorRef } from '@angular/core';
import { isPlatformBrowser, NgIf, NgClass, NgFor } from '@angular/common';
import { UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormDataHelper, TranslateHelper } from '@app/_helpers';
import { ChatService } from '@app/_services/chat.service';
import { DirectionService } from '@app/_services/direction.service';
import { DateTime } from 'luxon';
/* import { ObjectId } from 'bson'; */
import { AuthenticationService } from '@app/_services';
import * as _ from 'lodash';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { DeviceDetectorService } from 'ngx-device-detector';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { BidiModule } from '@angular/cdk/bidi';
import { ExtendedModule } from '@angular/flex-layout/extended';

@Component({
    selector: 'app-page-live-chat',
    templateUrl: './page-live-chat.component.html',
    styleUrls: ['./page-live-chat.component.scss'],
    providers: [FormDataHelper, TranslateHelper],
    standalone: true,
    imports: [NgIf, NgClass, ExtendedModule, BidiModule, NgFor, MatIconModule, MatButtonModule, RouterLink, FormsModule, ReactiveFormsModule, TranslateModule]
})
export class PageLiveChatComponent implements OnInit {
    @ViewChild('chatContent') private chatContent: ElementRef;
    @ViewChild('fileUpload') private fileUpload: ElementRef;
    @Input() modalMode: boolean = false;
    @Input() bsModalRef: BsModalRef = null;
    @Input() chatId: string;
    dir: string = 'ltr';
    showSideNav: boolean = false;
    userDetails: any;
    chatList: any;
    chatWindow: any = false;
    messageInput = new UntypedFormControl('');
    files: Array<any> = [];
    fileTypes: Array<string> = [
        'text/csv',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/pdf',
        'application/vnd.rar',
        'text/plain',
        'application/zip'
    ];
    imageTypes: Array<string> = [
        'image/gif',
        'image/jpeg',
        'image/png'
    ];
    _ = _;

    constructor(
        public direction: DirectionService,
        public translateHelper: TranslateHelper,
        public deviceDetector: DeviceDetectorService,
        // private cdr: ChangeDetectorRef,
        private authService: AuthenticationService,
        private chatService: ChatService,
        private formData: FormDataHelper,
        private toast: ToastrService,
        @Inject(PLATFORM_ID) private platformId: any
    ) {
        this.dir = this.direction.isRTL() ? 'rtl' : 'ltr';
    }

    ngOnInit(): void {
        this.chatService.wsChat$.subscribe((res: any) => {
            if (res.type == 'new_chat_message') {
                // console.log(this.chatWindow);

                let message = res.data.message;
                let chatIndex = _.findIndex(this.chatList, (chat: any) =>  chat._id == res.data._id);
                this.pushChatMessage(chatIndex, message);

                let sideMessage = message.files?.length ? message.files?.length + ' Files uploaded' : message.msg;
                this.updateSideNaveMessage(chatIndex, sideMessage, message.timestamp);

                if (this.chatWindow?.chatId == res.data?._id) {
                    this.chatService.sendMessage({
                        type: "mark_read",
                        chatId: this.chatList[chatIndex]?._id,
                        _id: res.data?.message?._id});
                }
            }
        });

        this.authService.currentUser.subscribe(user => {
            this.userDetails = user;
        });

        this.chatService.getAllChats().subscribe((response: any) => {
            this.chatList = response.data;

            if (this.chatId?.length) {
                let chatId = this.chatId;
                let chatIndex = _.findIndex(this.chatList, function (chat: any) { return chat._id == chatId; });
                if (chatIndex == -1) {
                    chatIndex = this.chatList.length;
                    this.chatService.getChat(this.chatId).subscribe((response: any) => {
                        this.chatList.push(response.data);
                        this.openChatWindow(chatIndex);
                    });
                } else {
                    this.openChatWindow(chatIndex);
                }
            }
        });
    }

    @HostListener('scroll', ['$event'])
    onScroll(event: any) {
        if (event.target.scrollTop == 0) {
            let chat = this.chatList[this.chatWindow?.index];
            if (chat.totalPages > chat.currentPage) {
                this.loadNextPage();
            }
        }
    }

    private loadNextPage(): void {
        let chat = this.chatList[this.chatWindow?.index];
        chat.currentPage++;

        this.chatService.getConversation({ chatId: this.chatWindow.chatId, page: chat.currentPage }).subscribe((response: any) => {
            if (_.isEmpty(response.data)) return;
            chat.messagesData = [...response.data, ...chat.messagesData];
            chat.messagesData.totalPages = response.pages;

            let firstDate = this.chatWindow?.messagesData?.[0]?.dateOnly;
            if (firstDate) {
                let messageDate: any = this.timestampToDateString(_.last<any>(response.data)?.timestamp);
                if (messageDate == firstDate) {
                    this.chatWindow.messagesData.shift();
                }
            }

            let currentContentHieght = this.chatContent.nativeElement.scrollHeight;

            this.chatWindow.messagesData = [...this.getChatMessages(response.data), ...this.chatWindow.messagesData];

            if (isPlatformBrowser(this.platformId)) {
                setTimeout(() => {
                    try {
                        this.chatContent.nativeElement.scrollTop = (this.chatContent.nativeElement.scrollHeight - currentContentHieght);
                    } catch (err) {
                        console.log(err);
                    }
                }, 0);
            }
        });
    }

    private timestampToDateString(timestamp, today?) {
        if (!today) today = DateTime.fromJSDate(new Date());
        let messageDate: any = DateTime.fromISO(timestamp);
        if (messageDate.toLocaleString() == today.toLocaleString()) {
            messageDate = "Today";
        } else if (messageDate.toFormat('y') == today.toFormat('y')) {
            messageDate = messageDate.toLocaleString({ month: 'long', day: 'numeric' });
        } else {
            messageDate = messageDate.toLocaleString(DateTime.DATE_FULL);
        }
        return messageDate;
    }

    private getChatMessages(messages: any[]): any[] {
        let currentAuthor;
        let currentDate;
        let dateInserts: any[] = [];
        let today = DateTime.fromJSDate(new Date());
        let dateChanged = false;
        _.each(messages, (message, index) => {
            if (message.dateOnly) {
                currentDate = message.dateOnly;
                dateChanged = true;
                return true;
            }
            message.head = false;

            let messageDate: any = this.timestampToDateString(message.timestamp, today);

            if (messageDate && messageDate != currentDate) {
                dateInserts.push({ index, date: messageDate });
                currentDate = messageDate;
                dateChanged = true;
            }
            if (dateChanged || (message?.senderData?.email && message.senderData.email != currentAuthor)) {
                message.head = true;
                currentAuthor = message.senderData.email;
                dateChanged = false;
            }
        });
        let indexOffset = 0;
        _.each(dateInserts, (insert) => {
            messages.splice(insert.index + indexOffset, 0, { dateOnly: insert.date });
            indexOffset++;
        });
        return messages;
    }

    getChatTitle(chat): string {
        if (chat.companyData?.name) {
            return this.translateHelper.localize(chat.companyData?.name);
        }

        switch (chat.type) {
            case 'support': return 'Qetaat support';
            case 'consult': return 'Qetaat consultation';

            default: return 'Qetaat support';
        }
    }

    openSideNav(): void {
        this.showSideNav = true;
    }

    closeSideNav(): void {
        this.showSideNav = false;
    }

    scrollToBottom(): void {
        if (isPlatformBrowser(this.platformId)) {
            setTimeout(() => {
                try {
                    this.chatContent.nativeElement.scrollTop = this.chatContent.nativeElement.scrollHeight;
                } catch (err) {
                    console.log(err);
                }
            }, 0);
        }
    }

    getMessageTime(timestamp): string {
        if (!timestamp) {
            return '';
        }

        // this.cdr.detectChanges();
        let time = DateTime.fromISO(timestamp);
        /* if (time.diffNow('seconds').seconds > -60) {
            return 'NOW';
        } */
        return time.toLocaleString(DateTime.TIME_SIMPLE);
    }

    private getChatWindow(companyData) {
        this.deselectFiles();

        this.chatWindow = companyData;
        let chat = this.chatList[companyData.index];

        if (!chat.messagesData) {
            chat.messagesData = [];

            this.chatService.getConversation({ chatId: companyData.chatId }).subscribe((response: any) => {
                chat.messagesData = response.data;
                chat.totalPages = response.pages;
                chat.currentPage = 1;
                this.chatWindow.messagesData = this.getChatMessages(response.data);
                this.scrollToBottom();
            });
        } else {
            this.chatWindow.messagesData = this.getChatMessages(chat.messagesData);
            this.scrollToBottom();
        }
    }

    openChatWindow(index): void {
        this.closeSideNav();

        this.getChatWindow({
            index: index,
            chatId: this.chatList[index]._id,
            name: this.getChatTitle(this.chatList[index]),
            messagesData: []
        });
    }

    pushChatMessage(index, message): void {
        let chatData = this.chatList[index];
        message.head = true;
        if (chatData?.messagesData) {
            let lastMessage = _.last<any>(chatData.messagesData);
            if(lastMessage?.senderData?.email == message?.senderData?.email) {
                let messageDate: any = this.timestampToDateString(message.timestamp);
                let lastMessageDate: any = this.timestampToDateString(lastMessage.timestamp);
                if(messageDate == lastMessageDate) message.head = false;
            }
            chatData.messagesData.push(message);
        } else {
            chatData.messagesData = [message];
        }
        this.scrollToBottom();
    }

    updateSideNaveMessage(index, message, timestamp): void {
        let chatData = this.chatList[index];
        _.set(chatData, 'message.msg', message);
        _.set(chatData, 'message.timestamp', timestamp);
    }

    sendChatMessage(): void {
        let messageValue = this.messageInput.value?.trim();

        if (messageValue) {
            let timestamp = new Date().toISOString();
            this.updateSideNaveMessage(this.chatWindow.index, messageValue, timestamp);

            this.chatService.sendMessage({
               /*  _id: new ObjectId().toHexString(), */
                chatId: this.chatWindow.chatId,
                message: messageValue,
                type: 'reply'
            });

            this.scrollToBottom();
        }

        this.messageInput.reset();
    }

    deselectFiles() {
        this.fileUpload.nativeElement.value = '';
        this.files = [];
    }

    isFileImage(mimeType: string) {
        return this.imageTypes.includes(mimeType);
    }

    isFileValid(mimeType: string) {
        return this.fileTypes.includes(mimeType) || this.isFileImage(mimeType);
    }

    onFileDropped(event, notInput: boolean = false) {
        let fileList: Array<any>;

        if (notInput) {
            fileList = [...event.dataTransfer?.files];
        } else {
            fileList = [...event.target.files];
        }

        event.preventDefault();

        if (fileList?.length) {
            if ((this.files.length + fileList.length) > 8) {
                this.toast.error('File Upload Limited to 8 Files Per Message.');
                return;
            }

            fileList.forEach(file => {
                if (file.size > 2097152) {
                    return this.toast.error('File is Larger than 2MB.');
                }

                if (!this.isFileValid(file.type)) {
                    return this.toast.error('File Type Is not acceptable. (' + file.name.toString() + ')');
                }

                this.files.push(file);
            });
        }
    }

    sendFiles() {
        if (this.files?.length) {
            let message = {
               /*  _id: new ObjectId().toHexString(), */
                chatId: this.chatWindow.chatId,
                message: '',
                type: 'reply',
                files: this.files
            };

            let timestamp = new Date().toISOString();
            this.updateSideNaveMessage(this.chatWindow.index, this.files.length + ' Files uploaded', timestamp);

            let formData = this.formData.ToFormData(message);
            this.chatService.fileUpload(this.chatWindow.chatId, formData).subscribe((response) => {
                // console.log(response);
            });
        }

        this.deselectFiles();
    }
}
